import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useDataModel, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { DataModelSchema } from 'schemas';
import { CircularProgress, Backdrop } from '@mui/material';
import DataModelViewDumb from './DataModelViewDumb';


const DataModelViewSmart = (props) => {
  const { match: { params } } = props;
  const { projectId, dataModel } = params;
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);

  const {
    cleanUpMessage,
    error,
    success,
    getDataModel,
    data,
    isLoaded
  } = useDataModel();

  const [defaultValues, setDefaultValues] = useState({
    name: '',
    project: {},
    additionalVariables: '',
    language: 'json',
  });

  const findProyectById = (projectId) => projects.find(p => Number(p.value) === Number(projectId));

  useEffect(() => {
    if (!!success.get) handleData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get]);

  useLayoutEffect(() => {
    const proyect =  findProyectById(projectId)
    const query = {
      baseUrl: proyect.base_url,
      file: dataModel
    }
    getDataModel({ query});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseAlert = () => cleanUpMessage();

  function handleData() {
    const nameSplit = dataModel.split('.');
    let additionalVariables = data;
    if (nameSplit[1] === 'json') {
      additionalVariables = JSON.stringify(data, null, 2);
    }
    setDefaultValues({
      name: nameSplit[0],
      project: findProyectById(projectId),
      additionalVariables,
      language: (nameSplit[1] === 'md') ? 'json' : nameSplit[1]
    })
  };

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (data && projects && defaultValues.additionalVariables.length > 0) ?
        (
          <DataModelViewDumb
            defaultValues={defaultValues}
          />
        )
        :(
          <ErrorScreen />
        )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="dataModelCreate.components.alert.error" />
    </>
  );
};

export default withRequest(withRouter(DataModelViewSmart));
